import styled from 'styled-components';
import Button from '@sdk/components/primitives/Button';

export type EditorToolbarButtonProps = {
  isActive?: boolean;
  mRight?: number;
  borderRadius?: number;
};

const EditorToolbarButton = styled(Button)<EditorToolbarButtonProps>`
  margin-right: ${({ mRight }): number => mRight || 0}px;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ isActive, theme }): string =>
    isActive ? theme.colors.bodyBgDark : 'transparent'};
  border-radius: ${({ borderRadius }): number => borderRadius || 0}px;

  &:hover {
    ${({ isActive, theme }): string =>
      isActive ? '' : `background-color: ${theme.colors.hoverBrand};`}
  }
`;

export default EditorToolbarButton;
